import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FiCalendar, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Register = () => {
  const { register } = useAuth();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    hoTen: '',
    email: '',
    matKhau: '',
    xacNhanMatKhau: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.matKhau !== formData.xacNhanMatKhau) {
      toast.error(t('auth.passwordMismatch'));
      return;
    }

    if (formData.matKhau.length < 8) {
      toast.error(t('auth.passwordTooShort'));
      return;
    }

    setLoading(true);
    try {
      const result = await register(formData.hoTen, formData.email, formData.matKhau);
      if (result.success) {
        toast.success(t('auth.registerSuccess'));
      } else {
        toast.error(result.message || t('auth.registerFailed'));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || t('auth.errorOccurred'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-logo">
          <h1>
            <FiCalendar />
            {t('auth.registerTitle')}
          </h1>
          <p>{t('auth.registerSubtitle')}</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              <FiUser style={{ marginRight: '8px' }} />
              {t('auth.fullName')}
            </label>
            <input
              type="text"
              name="hoTen"
              value={formData.hoTen}
              onChange={handleChange}
              placeholder={t('auth.fullNamePlaceholder')}
              required
            />
          </div>

          <div className="form-group">
            <label>
              <FiMail style={{ marginRight: '8px' }} />
              {t('auth.email')}
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t('auth.emailPlaceholder')}
              required
            />
          </div>

          <div className="form-group">
            <label>
              <FiLock style={{ marginRight: '8px' }} />
              {t('auth.password')}
            </label>
            <input
              type="password"
              name="matKhau"
              value={formData.matKhau}
              onChange={handleChange}
              placeholder={t('auth.passwordMinLength')}
              required
            />
          </div>

          <div className="form-group">
            <label>
              <FiLock style={{ marginRight: '8px' }} />
              {t('auth.confirmPassword')}
            </label>
            <input
              type="password"
              name="xacNhanMatKhau"
              value={formData.xacNhanMatKhau}
              onChange={handleChange}
              placeholder={t('auth.confirmPasswordPlaceholder')}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? t('auth.processing') : t('auth.registerBtn')}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            {t('auth.hasAccount')} <Link to="/login">{t('auth.loginLink')}</Link>
          </p>
          <p style={{ marginTop: '12px' }}>
            <Link to="/" style={{
              color: 'var(--text-secondary)',
              fontWeight: '500',
              textDecoration: 'none',
              fontSize: '14px'
            }}>
              ← {t('landing.backHome')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
